import { render, staticRenderFns } from "./DepartmentAttendersSection.vue?vue&type=template&id=471bfa92&scoped=true&"
import script from "./DepartmentAttendersSection.vue?vue&type=script&lang=js&"
export * from "./DepartmentAttendersSection.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentAttendersSection.vue?vue&type=style&index=0&id=471bfa92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471bfa92",
  null
  
)

export default component.exports